/**
 * PaletteChip — single clickable token in the BlocksPalette
 * For Media Devoted | Created By Ciro Autiero
 */

import { memo } from 'react';
import type { FC, ReactNode } from 'react';

export type PaletteTone = 'metric' | 'subref' | 'number' | 'op' | 'fn' | 'punct';

const TONE_STYLES: Record<PaletteTone, string> = {
  metric: 'bg-primary/10 text-primary hover:bg-primary/20 border-primary/30',
  subref: 'bg-success/15 text-success hover:bg-success/25 border-success/40',
  number: 'bg-card text-foreground hover:bg-muted border-border',
  op: 'bg-warning/15 text-foreground hover:bg-warning/25 border-warning/40',
  fn: 'bg-accent text-accent-foreground hover:bg-accent/80 border-accent',
  punct: 'bg-muted text-muted-foreground hover:bg-muted/70 border-border',
};

export interface PaletteChipProps {
  tone: PaletteTone;
  onClick: () => void;
  children: ReactNode;
}

const PaletteChip: FC<PaletteChipProps> = ({ tone, onClick, children }) => (
  <button
    type="button"
    onClick={onClick}
    className={`inline-flex items-center rounded-md border px-2 py-1 text-xs font-medium tabular-nums transition-colors ${TONE_STYLES[tone]}`}
  >
    {children}
  </button>
);

export default memo(PaletteChip);

export const PaletteSection: FC<{ label: string; children: ReactNode }> = ({ label, children }) => (
  <div className="flex flex-wrap items-center gap-3">
    <span className="w-20 shrink-0 text-[11px] font-semibold uppercase tracking-wide text-muted-foreground">
      {label}
    </span>
    <div className="flex min-w-0 flex-1 flex-wrap items-center gap-1.5">{children}</div>
  </div>
);
